import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, ConvertStatus, DELETE_ROW, JSON_KEY_CODE, JSON_KEY_DESCRIPTION, 
   JSON_KEY_PARTICIPANT_TYPE, JSON_KEY_STATUS, TABLE_HEADER_CODE,  
   // JSON_KEY_ID, TABLE_HEADER_ID, 
   TABLE_HEADER_DESCRIPTION, TABLE_HEADER_STATUS, TABLE_HEADER_TYPE, UNKNOWN, UPDATE_ROW, 
   FIRM_TYPE_EXCHANGE, FIRM_TYPE_BROKER, FIRM_TYPE_DATAVENDOR, FIRM_TYPE_CLEARING, FIRM_TYPE_SURVEILLANCE,
   FIRM_TYPE_NAME_EXCHANGE, FIRM_TYPE_NAME_BROKER, FIRM_TYPE_NAME_DATAVENDOR, FIRM_TYPE_NAME_CLEARING, FIRM_TYPE_NAME_SURVEILLANCE,
   DROPDOWN_LIST_NONE, AddItemToDropdown,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor} 
from '../../common/common';
import FirmsAdminForm from '../forms/firms_admin_form';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

function ConvertParticipantType(type) {
   switch (type) {
      case (FIRM_TYPE_EXCHANGE):
         return FIRM_TYPE_NAME_EXCHANGE;
      case (FIRM_TYPE_BROKER):
         return FIRM_TYPE_NAME_BROKER;
      case (FIRM_TYPE_DATAVENDOR):
         return FIRM_TYPE_NAME_DATAVENDOR;
      case (FIRM_TYPE_CLEARING):
         return FIRM_TYPE_NAME_CLEARING;
      case (FIRM_TYPE_SURVEILLANCE):
         return FIRM_TYPE_NAME_SURVEILLANCE;
      default:
         return UNKNOWN;
   }
};

const Firms = () => {
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownTradingAccountData, setDropDownTradingAccountData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[ParticipantsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[ParticipantsTable] Row Double Clicked:`, rowData, ', isMarketController:', isMarketControllerRef.current);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log(`[ParticipantsTable] Event received:`, details.data);
      const raw = details.data;
      const formatted = {
         ...raw,
         id: raw.code,
         p_type: ConvertParticipantType(raw.p_type),
         status: ConvertStatus(raw.status),
      };
   
      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               if (prev.some(row => row.id === formatted.id)) {
                  console.log(`[ParticipantsTable] Row with id ${formatted.id} already exists, not adding.`);
                  return prev; // No duplicate entry
               }
               return [...prev, formatted];
            });
            
            AddItemToDropdown(setDropDownTradingAccountData, { id: details.data.code, name: details.data.code });
            break;
   
         case UPDATE_ROW:
            setLocalTableData(prev => prev.map(row => row.id === formatted.id ? formatted : row));
            break;
   
         case DELETE_ROW:
            setLocalTableData(prev => prev.filter(row => row.id !== raw.code));
            break;

         default:
            break;
      }
   }, [setDropDownTradingAccountData]);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
   
   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID },  // don't show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_PARTICIPANT_TYPE },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="ParticipantsTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
      
         <Modal show={showForm} onHide={handleCloseForm}>
            <FirmsAdminForm rowData={selectedRow} onClose={handleCloseForm} firmOptions={dropDownTradingAccountData} />
         </Modal>
      </>
   );
};

export default Firms;
